import { render, staticRenderFns } from "./resizable-textarea.vue?vue&type=template&id=2e151507"
import script from "./resizable-textarea.vue?vue&type=script&lang=js"
export * from "./resizable-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports